import { useGetProductReviewsQuery } from '../api/product-reviews-api'

import { DEFAULT_REVIEW_MEDIA_LIMIT, DEFAULT_REVIEWS_LIMIT } from './constants'
import type { ProductReviewsSummary } from './types'

type UseProductReviewsDataParams = {
	productCode?: number | string
	productCodes: number[]
	productImages: string[]
	focusReviewId?: number
	token?: string
	cachedSummary?: ProductReviewsSummary
	limit?: number
	includeSummary?: boolean
	includeMedia?: boolean
	enabled?: boolean
}

export const useProductReviewsData = ({
	productCode,
	productCodes,
	productImages,
	focusReviewId,
	token,
	cachedSummary,
	limit = DEFAULT_REVIEWS_LIMIT,
	includeSummary = true,
	includeMedia = true,
	enabled = true
}: UseProductReviewsDataParams) => {
	const { data, isError, isLoading, isUninitialized } = useGetProductReviewsQuery(
		{
			productCode: Number(productCode),
			productCodes,
			sort: 'newest',
			variant: 'all',
			limit,
			mediaLimit: DEFAULT_REVIEW_MEDIA_LIMIT,
			currentPage: 1,
			productImages,
			reviewId: focusReviewId,
			cachedSummary,
			includeSummary,
			includeMedia,
			token
		},
		{
			skip: !enabled || !productCode || productCodes.length === 0,
			refetchOnFocus: false,
			refetchOnReconnect: false,
			refetchOnMountOrArgChange: false
		}
	)

	return {
		data: isError ? null : data ?? null,
		isLoading: enabled && (isLoading || isUninitialized)
	}
}
